// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"7200bf56","455":"f14c382a","977":"30d7a6ed"}[chunkId] + ".chunk.js";
};